module.exports = __webpack_public_path__ + "img/4-3.76f52304.png";